goog.provide('el8.appchart.actions.dcMedOrderNew');

goog.require('el8.uiwidget.deleteConfirm');


el8.appchart.actions.dcMedOrderNew = function(opts) {
    opts = opts || {};
    var item = opts.item;
    var menu = [];

    if (el8Globals.READ_ONLY) {
        return menu; // All menu action items currently require write access
    }

    // left
    menu.push({type: 'heading', actionText: 'Send:'});

    menu.push({
        actionText: 'Office Message',
        actionFn: function() {
            el8.appshared.message.prePopulateNewMessage({
                toDocId: item.getId()
            });
        },
        indent: true
    });

    menu.push({type: 'heading', actionText: 'Export to Note:'});

    menu.push({
        actionText: 'as HPI',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
        },
        indent: true
    });
    menu.push({
        actionText: 'as Meds',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item});
        },
        indent: true
    });

    // right

    menu.push({
        actionText: 'Reorder',
        actionFn: function() {
            var order = el8.ptdata.fetchById(item.getMedOrderId());
            el8.appchart.mgr.orderForm.reOrderMedOrder(order);
        },
        right: true
    });

    menu.push({type: 'line', right: true});

    menu.push({
        actionText: 'Move to Other Med',
        actionFn: function() {
            el8.appchart.medsHx.main.show({
                dcMedOrderId: item.getId(),
                doMoveMerge: true
            });
        },
        right: true
    });

    menu.push({type: 'line', right: true});

    menu.push({
       actionText: 'Remove',
       actionFn: function() {
            el8.uiwidget.deleteConfirm("discontinue med order",
                function() {
                    el8.ptdata.dcMedOrders.deleteItem(item);
                }
            );
       },
       type: 'remove',
       right: true
    });

    return menu;
};

